import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { reduxForm, formValueSelector, Field, FieldArray } from 'redux-form';
import ApplicantData from './ApplicantData';
import FormImageUpload from '../legacyForm/FormImageUpload';
import FormSelect from '../legacyForm/FormSelect';
import AddIcon from '@material-ui/icons/AddBox';
import { Button, Divider, Typography } from '@material-ui/core';
import CategoryLocationsAutocompletion from './CategoryLocationsAutocompletion';
import BudgetApplicationFormItems from './BudgetApplicationFormItems';

export const validateForm = form => {
  const errors = {};

  if (!form.voter || !form.voter.participantType) errors.voter = { participantType: 'Wybór osoby zgłaszającej projekt jest wymagany' };
  return errors;
};

const required = value => value ? undefined : 'Pole jest wymagane';

const selector = formValueSelector('applicationForm');

let BudgetManualApplicationForm = ({
  handleSubmit,
  change,
  submitting,
  applicationForm,
  disabled,
  district,
  category,
  costs,
  budget,
  parcelsAutocompletion,
  locations,
  voter }) => {
  const totalCost = costs ? costs.filter(c => c.value).map(c => c.value).reduce((a, b) => a + b, 0) : 0;
  const locationDependantCategory = category && applicationForm.categories.find(c => c.name === category).subcategoriesLocationDependent;
  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="row">
        <div className="box-header-outside">
          <div className="col-sm-12">
            <div className="header">
              <h2>Formularz zgłoszenia</h2>
            </div>
          </div>
        </div>
        <BudgetApplicationFormItems
          applicationForm={applicationForm}
          change={change}
          budget={budget}
          parcelsAutocompletion={parcelsAutocompletion}
          locations={locations}
          totalCost={totalCost}
        />
        {applicationForm.districts && applicationForm.districts.length > 0 ? <div className="box">
          <div className="col-sm-12">
            <h3>Obszar</h3>
            <div>
              <Field
                name="district"
                component={FormSelect}
                label="Wybierz obszar"
                values={
                  applicationForm.districtsAttributes && applicationForm.districtsAttributes.length
                    ? applicationForm.districtsAttributes
                      .filter(c => !c.costDependent || (totalCost >= c.minimumCost && totalCost <= c.maximumCost))
                      .map(d => ({ value: d.name, name: d.name }))
                    : applicationForm.districts.map(d => ({ value: d, name: d }))}
                validate={required}
                onChange={() => {
                  change('category', null);
                }}
              />
            </div>
            {totalCost > 0 && applicationForm.districtsAttributes && applicationForm.districtsAttributes.length && !applicationForm.districtsAttributes
              .filter(c => !c.costDependent || (totalCost >= c.minimumCost && totalCost <= c.maximumCost))
              .length
              ? <Typography variant="caption" color="error" style={{ marginTop: 10 }}>Brak dostępnych obszarów dla wskazanego kosztu projektu</Typography> : null}
          </div>
        </div> : null}
        {applicationForm.categories && applicationForm.categories
          .filter(c => !applicationForm.districts || !applicationForm.districts.length || (c.districts && c.districts.some(d => d === district))).length > 0 ? <div className="box">
            <div className="col-sm-12">
              <h3>Kategoria</h3>
              <div>
                <Field
                  name="category"
                  component={FormSelect}
                  label="Wybierz kategorię"
                  values={applicationForm.categories
                    .filter(c => !c.costDependent || (totalCost >= c.minimumCost && totalCost <= c.maximumCost))
                    .filter(c => !applicationForm.districts || !applicationForm.districts.length || (c.districts && c.districts.some(d => d === district))).map(c => ({ value: c.name, name: c.name }))}
                  validate={required}
                  onChange={() => {
                    change('subcategory', null);
                  }}
                />
              </div>
              {totalCost > 0 && !applicationForm.categories
                .filter(c => !c.costDependent || (totalCost >= c.minimumCost && totalCost <= c.maximumCost))
                .filter(c => !applicationForm.districts || !applicationForm.districts.length || (c.districts && c.districts.some(d => d === district))).map(c => ({ value: c.name, name: c.name }))
                .length
                ? <Typography variant="caption" color="error" style={{ marginTop: 10 }}>Brak dostępnych kategorii dla wskazanego kosztu projektu</Typography> : null}
            </div>
          </div> : null}
        {
          locationDependantCategory &&
          <div className="box">
            <div className="col-sm-12">
              <h3>Lokalizacja</h3>
              <Field
                name="subcategory"
                component={CategoryLocationsAutocompletion}
                subcategories={applicationForm.categories
                  .find(c => c.name === category).subcategories
                  .filter(c => !c.costDependent || (totalCost >= c.minimumCost && totalCost <= c.maximumCost))}
                onLocationSelected={subcategory => {
                  change('subcategory', subcategory);
                }}
                validate={required}
              />
            </div>
          </div>
        }
        {category && applicationForm.categories.find(c => c.name === category).subcategories && applicationForm.categories.find(c => c.name === category).subcategories.length > 0 ? <div className="box">
          <div className="col-sm-12">
            <h3>Podkategoria</h3>
            {locationDependantCategory &&
              <Typography variant="caption">Podkategoria zostanie wybrana na podstawie wskazanej powyżej lokalizacji</Typography>}
            <div>
              <Field
                name="subcategory"
                component={FormSelect}
                disabled={locationDependantCategory}
                label={locationDependantCategory ? '' : 'Wybierz podkategorię'}
                values={applicationForm.categories.find(c => c.name === category).subcategories
                  .filter(c => !c.costDependent || (totalCost >= c.minimumCost && totalCost <= c.maximumCost))
                  .map(c => ({ value: c.name, name: c.name }))}
                validate={required}
              />
            </div>
          </div>
        </div> : null}
        {applicationForm.listOfSupport && <div className="box">
          <div className="col-sm-12">
            <h3>Lista poparcia</h3>
            {applicationForm.listOfSupportDescription ? <p>{applicationForm.listOfSupportDescription}</p> : null}
            <div>
              <Field
                type="file"
                name="attachment"
                component={FormImageUpload}
                validate={required}
              />
            </div>
          </div>
        </div>}
        {applicationForm.eListOfSupportEnabled && <div className="box">
          <div className="col-sm-12">
            <h3>Elektroniczna lista poparcia</h3>
            {applicationForm.eListOfSupport.description ? <p>{applicationForm.eListOfSupport.description}</p> : null}
            <p>Adres elektronicznego poparcia zostanie wyświetlony po wysłaniu projektu</p>
          </div>
        </div>}
        {applicationForm.additionalAttachments && <div className="box">
          <div className="col-sm-12">
            <h3>Załączniki</h3>
            {applicationForm.additionalAttachmentsDescription ? <p>{applicationForm.additionalAttachmentsDescription}</p> : null}
            <div>
              <FieldArray name="attachments" component={({ fields }) => (
                <div>
                  {fields.map((name, index) => (
                    <div key={index} style={{ marginBottom: 10 }}>
                      <Field
                        type="file"
                        name={name}
                        component={FormImageUpload}
                      />
                      <Divider />
                    </div>
                  ))}
                  <Button color="primary" onClick={() => fields.push()}>
                    <AddIcon style={{ marginRight: 8 }} /> Dodaj załącznik
                  </Button>
                </div>
              )} />
            </div>
          </div>
        </div>}
      </div>
      <div className="row">
        <div className="box-header-outside">
          <div className="col-sm-12">
            <div className="header">
              <h2>{applicationForm.voterRequiredDataDescription ? applicationForm.voterRequiredDataDescription : "Dane osoby zgłaszającej projekt"}</h2>
              <p>W przypadku kilku wnioskodawców proszę wpisać dane wnioskodawcy głównego</p>
            </div>
          </div>
        </div>
        <div className="box">
          <div className="col-sm-12">
            {voter && <ApplicantData voterRequiredData={applicationForm.voterRequiredData || {}} voter={voter} change={change} />}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12" style={{ marginRight: 15 }}>
          <button type="submit" disabled={submitting || disabled} className="btn btn-send">
            {submitting ? 'Zapisywanie...' : 'Dodaj projekt'} <i className="fa fa-paper-plane" />
          </button>
        </div>
      </div>
    </form>
  );
};

BudgetManualApplicationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  details: PropTypes.array,
  applicationForm: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  district: PropTypes.string,
  category: PropTypes.string,
  costs: PropTypes.array,
  budget: PropTypes.object.isRequired,
  parcelsAutocompletion: PropTypes.bool,
  locations: PropTypes.array,
  voter: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    details: selector(state, 'details'),
    district: selector(state, 'district'),
    category: selector(state, 'category'),
    costs: selector(state, 'costs'),
    locations: selector(state, 'locations'),
    voter: selector(state, 'voter'),
  };
}

BudgetManualApplicationForm = reduxForm({
  form: 'applicationForm',
  enableReinitialize: true,
  validate: validateForm,
})(BudgetManualApplicationForm);

export default compose(connect(mapStateToProps))(BudgetManualApplicationForm);



// WEBPACK FOOTER //
// ./src/components/budget/BudgetManualApplicationForm.js